module.exports = __webpack_public_path__ + "img/ico-acc.c1d3a487.svg";